import { render, staticRenderFns } from "./PartnerAcceptContract.vue?vue&type=template&id=806601b0&scoped=true&"
import script from "./PartnerAcceptContract.vue?vue&type=script&lang=js&"
export * from "./PartnerAcceptContract.vue?vue&type=script&lang=js&"
import style0 from "./PartnerAcceptContract.vue?vue&type=style&index=0&id=806601b0&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "806601b0",
  null
  
)

export default component.exports